import React from "react";
import { IFieldDetails, IInitialState, SchedulingModes } from "../../../CreateSchedule/redux/Types";
import { getWeekOfTheMonthTypes, getDaysOfTheWeek, getDayRadioOptions } from "../../GetDataSourceValues";
import {
  Dropdown,
  Input,
  FormElement,
  RadioButtons
} from "../../../../../Common/UI/Index";
import { InputType } from "../../../../../Common/UI/Types";
import "../Common/Style.scss";

export interface IDaysConfigViewProps {
  onDayRadioChange: (selectedValue: string) => void;
  onDayTextInputChange: (e: React.SyntheticEvent<any, Event>) => void;
  onWeekOfTheMonthOptionChange: (selectedValue: string) => void;
  onWeekDayOfTheMonthOptionChange: (selectedValue: string) => void;
  day: IFieldDetails;
  scheduling: IInitialState;
  disabledDayText: boolean;
  disableTheWeekDrpDwn: boolean;
}

const DaysConfigView = (props: IDaysConfigViewProps): JSX.Element => {
  const { onDayRadioChange, onDayTextInputChange,
    onWeekOfTheMonthOptionChange, onWeekDayOfTheMonthOptionChange, day,
    scheduling, disabledDayText, disableTheWeekDrpDwn } = props;
  const { schedulingDetails } = scheduling;
  const { recurrenceData } = schedulingDetails;
  const dayValue = (recurrenceData?.day) ? String(recurrenceData?.day) : "1";
  const calculation = recurrenceData && recurrenceData.calculation;
  const weekValue = (calculation) ? calculation[0] : getWeekOfTheMonthTypes[0].value;
  const dayWeekValue = (calculation) ? calculation[1] : getDaysOfTheWeek[0].value;
  const disabledFields = scheduling.mode === SchedulingModes.VIEW;
  const radioSelection = recurrenceData?.day ? "1" : "2";
  const options = getDayRadioOptions(disabledFields);
  return (
    <div className="ebt-monthly-container" data-testid="day-week-container">
      <div className="ebt-monthly-container_day" data-testid="day-week-day-container">
        <RadioButtons
          data-testid="day-week-radio"
          defaultValue={radioSelection}
          options={options}
          onClickEvent={onDayRadioChange}
          disableFields={disabledFields}
        />
      </div>
      <div className="ebt-monthly-container_content">
        <FormElement fieldId="monthDayId" mandatory={true}
          errorText={day.errorText}>
          <Input
            id="monthDayId"
            className="ebt-monthly-container_content__value"
            onChange={onDayTextInputChange}
            value={dayValue}
            type={InputType.Text}
            name="monthDay"
            data-testid="schedule-monthDay"
            required={true}
            disabled={disabledDayText}
          />
          <div className="ebt-monthly-container_content__weeks">
            <Dropdown dataSource={getWeekOfTheMonthTypes}
              className="ebt-monthly-container_content__weeks-month"
              onChange={onWeekOfTheMonthOptionChange}
              data-testid="day-week_week_month"
              name="week_month"
              value={weekValue}
              disabled={disableTheWeekDrpDwn}
            />
            <Dropdown dataSource={getDaysOfTheWeek}
              className="qbl-week_day"
              onChange={onWeekDayOfTheMonthOptionChange}
              data-testid="day-week_day_week"
              name="day_week"
              value={dayWeekValue}
              disabled={disableTheWeekDrpDwn} />
          </div>
        </FormElement>
      </div>
    </div>);
};

export default DaysConfigView;

